export var MarvColorPrimary = 'primary';
export var MarvColorSecondary = 'secondary';
export var MarvColorBlue = 'blue';
export var MarvColorRed = 'red';
export var MarvColorGreen = 'green';
export var MarvColorOrange = 'orange';
export var MarvColorPurple = 'purple';
export var MarvColorMarvesting = 'marvesting';
export type MarvColor = typeof MarvColorPrimary
    | typeof MarvColorPrimary
    | typeof MarvColorBlue
    | typeof MarvColorRed
    | typeof MarvColorGreen
    | typeof MarvColorOrange
    | typeof MarvColorPurple
    | typeof MarvColorMarvesting;